import { useEffect, useRef, useState } from "react";
import { HiOutlineChevronLeft, HiOutlineChevronRight } from "react-icons/hi2";
import Axios from "../../../Axios";
import { Carousel, Slide } from "../../../ui/Carousel/Carousel";
import { Card, CardContent } from "../../ui/card";
import { Badge } from "../../ui/badge";
import { Button } from "../../ui/button";

import "./banner.scss";

const fallbackHero = require("../../../assets/header.jpg");
const DEFAULT_EYEBROW = "ПРЕМИУМ СУРГАЛТ";
const DEFAULT_TITLE = "Ochiroo's Theory";
const DEFAULT_DESCRIPTION = "10+ жилийн судалгааны үр дүн бий болсон дэлхийд гарах оюун.";

const Banner = () => {
  const carouselRef = useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;

    Axios.get("/fopperies/1/list")
      .then((res) => {
        if (!active || res.status !== 200) {
          return;
        }

        let DATA = res.data;

        if (res.data.length === 1) {
          DATA = [res.data[0], res.data[0]];
        }

        setData(DATA);
      })
      .finally(() => {
        if (active) {
          setIsLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  const slides =
    Array.isArray(data) && data.length > 0
      ? data
      : [{ id: "fallback", image: fallbackHero }];

  if (isLoading) {
    return (
      <div className="homeHero" aria-busy="true" aria-live="polite">
        <div className="mx-auto w-[min(1460px,calc(100%-16px))]">
          <Card className="overflow-hidden rounded-[22px] border border-blue-200/30 bg-slate-950">
            <CardContent>
              <div className="homeHero__skeleton h-[36vh] min-h-[250px] sm:h-[44vh] lg:h-[52vh] xl:h-[58vh]" />
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <section className="homeHero">
      <div className="mx-auto w-[min(1460px,calc(100%-16px))]">
        <Card className="overflow-hidden rounded-[22px] border border-blue-200/30 bg-slate-950 shadow-[0_26px_48px_rgba(15,23,42,0.24)]">
          <CardContent>
            <div className="relative h-[36vh] min-h-[250px] sm:h-[44vh] lg:h-[52vh] xl:h-[58vh]">
              <Carousel
                ref={carouselRef}
                autoplaySpeed={30000}
                autoplay
                infinite
                hiddenArrows
              >
                {slides.map((item) => (
                  <Slide key={item.id}>
                    <div className="relative h-full w-full">
                      <picture className="block h-full w-full">
                        {item.mobile_image ? (
                          <source media="(max-width: 768px)" srcSet={item.mobile_image} />
                        ) : null}
                        <img
                          src={item.image || fallbackHero}
                          alt="Ochiroo's Theory Hero"
                          className="h-full w-full object-cover object-center"
                        />
                      </picture>

                      <div className="absolute inset-0 bg-gradient-to-r from-[#020818]/90 via-[#0B2265]/50 to-[#0A3BA1]/20" />
                      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_10%,rgba(56,189,248,0.35),transparent_45%)]" />

                      <div className="absolute inset-y-0 left-10 right-10 z-10 top-[20%] flex items-center">
                        <div className="mx-4 w-full sm:mx-6 lg:mx-10 lg:max-w-[560px]">
                          <div className="rounded-2xl border border-white/15 bg-slate-900/35 p-4 backdrop-blur-md sm:p-5 lg:p-7">
                          <Badge>{item.eyebrow || DEFAULT_EYEBROW}</Badge>

                          <h1 className="mt-3 text-[26px] font-extrabold leading-[1.04] tracking-[-0.02em] text-white sm:text-[34px] lg:text-[48px]">
                            {item.title || DEFAULT_TITLE}
                          </h1>

                          <p className="mt-3 text-sm leading-relaxed text-blue-100/95 sm:text-base lg:max-w-[460px] lg:text-lg">
                            {item.description || DEFAULT_DESCRIPTION}
                          </p>

                          <div className="mt-5 flex items-center gap-2 sm:gap-3">
                            <Button
                              variant="default"
                              onClick={() =>
                                window.scrollTo({ top: window.innerHeight * 0.9, behavior: "smooth" })
                              }
                            >
                              Сургалтууд үзэх
                            </Button>
                            <Button
                              variant="outline"
                              onClick={() => window.open("https://t.me/ochirootrade", "_blank", "noopener,noreferrer")}
                            >
                              Telegram
                            </Button>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </Slide>
                ))}
              </Carousel>

              <div className="pointer-events-none absolute inset-y-0 left-0 right-0 z-20 flex items-center justify-between px-2 sm:px-4">
                <Button
                  variant="outline"
                  size="icon"
                  className="pointer-events-auto rounded-full"
                  aria-label="Previous slide"
                  onClick={() => carouselRef.current?.prev?.()}
                >
                  <HiOutlineChevronLeft className="text-[20px]" />
                </Button>
                <Button
                  variant="outline"
                  size="icon"
                  className="pointer-events-auto rounded-full"
                  aria-label="Next slide"
                  onClick={() => carouselRef.current?.next?.()}
                >
                  <HiOutlineChevronRight className="text-[20px]" />
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
export default Banner;
